import { format } from 'date-fns';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../../interfaces';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';
import { inspectionType } from '../../../constants/generals';

export interface IListItemProps {
    instance: MonthlyFormModel;
    index: number;
    history: IHistory;
}

export class ListItemImpl extends React.PureComponent<IListItemProps, {}> {

    static defaultProps: IListItemProps;

    render() {
        const { instance, index, history } = this.props;
        if (!instance) {
            return <div></div>;
        }
      /*  let type = instance.props.type;
         if(instance.props.type=='MonthlyUSTSpill')
            type = 'UST Spill Container';  */
        return <Row className="form-list-item" >
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item serial-no"
                sm={1}
                xs={1}
            >
                {index}
            </Col>
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item"
                xs={1}
                sm={1}
            >
                {instance.props.PlantId}
            </Col>
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item"
                xs={3}
                sm={3}
            >
                {instance.props.Region}
            </Col>
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item"
                xs={3}
                sm={3}
            >
                {inspectionType(instance.props.type)}
            </Col>
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item"
                xs={2}
                sm={2}
            >
                {format(instance.props.SubmittedDate, 'MM/DD/YYYY')}
            </Col>
            <Col
                onClick={() => history.push(`/reports/monthly/${instance.props.id}`)}
                className="clickable-list-item"
                xs={2}
                sm={2}
            >
                {instance.props.UpdatedDate} {/* N/A */}
            </Col>
            
        </Row>;
    }

}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Monthly/ListItem.tsx